module.exports = __webpack_public_path__ + "media/images/emblems/Albinen-coat_of_arms-d4157a78001b02653fe43929bedcc34a.svg";